export default __webpack_public_path__ + "static/media/TotemPrototype10.062b15e0.jpg";